import { FilterAltIcon } from "@l2r-front/l2r-icons"
import { undefinedFunctionWarning } from "@l2r-front/l2r-utils"

import { FilterBottomSheet } from "../FilterBottomSheet"

import * as Styled from "./FilterButton.styled"

export function FilterButton(props: FilterButtonProps): React.ReactElement {

    const {
        className,
        children,
        filterCount = 0,
        onClick,
        onClose,
        open,
        ...otherProps
    } = props

    return <div className={className}>
        <Styled.Fab color="primary" id="mobile-filters-button" size="small" onClick={onClick}>
            <FilterAltIcon color="action/selected" />
            {filterCount ? <Styled.FilterCount id="filter-count">
                <Styled.Typography variant="Desktop & Mobile/Body/Small">{filterCount}</Styled.Typography>
            </Styled.FilterCount> : null}
        </Styled.Fab>
        <FilterBottomSheet onOpen={() => undefinedFunctionWarning("onOpen")} open={open} onClose={onClose} {...otherProps}>
            {children}
        </FilterBottomSheet>
    </div>
}
type FilterButtonProps = {
    children: React.ReactNode,
    className?: string,
    filterCount?: number,
    open: boolean,
    onClick: () => void,
    onClose: () => void,
}